import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "../Slice/userSlice"; 
import snackbarReducer from "../Slice/snackbarSlice" ;
import credentialsReducer from "../Slice/credentialSlice"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "../Slice/authSlice" ;
import chatReducer from "../Slice/chatBoxSlice" 
import paymentLoadSlice from "../Slice/paymentLoadSlice"
import mcqReducer from "../Slice/mcqSlice" 
import courseReducer from "../Slice/courseSlice"
import adminReducer from "../Slice/adminSlice";
import { logout } from "../Slice/userSlice";
// Configure store with typed reducers
const appReducer = combineReducers({
  user: userReducer,
  snackbar: snackbarReducer,
  auth: authReducer,
  credentials: credentialsReducer,
  chatai: chatReducer,
  paymentLoader: paymentLoadSlice,
  mcq: mcqReducer,
  course: courseReducer,
  admin: adminReducer
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
  if (action.type === logout.type) {
    state = undefined;
  }

  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,

});

// Infer the `RootState` and `AppDispatch` types from the store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
